import Vue from 'vue';
import VueRouter from 'vue-router';

import HomePage from '@/views/HomePage';

Vue.use(VueRouter);

import store from '@/store';
import { getLoginToken } from '@/utils/auth';

const requireAuth = (to, from, next) => {
	const isLogin = store.getters['userStore/isLogin'];

	if (isLogin) next();
	else next('/login');
};

const guestAuth = (to, from, next) => {
	const isLogin = store.getters['userStore/isLogin'];

	if (isLogin) next('/');
	else next();
};

const routes = [
	{
		path: '/',
		name: 'home',
		component: HomePage,
		beforeEnter: requireAuth,
	},
	{
		path: '/editUser',
		name: 'editUser',
		component: () => import('@/views/EditUserPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/userLeave',
		name: 'userLeave',
		component: () => import('@/views/UserLeavePage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/mypage',
		name: 'mypage',
		component: () => import('@/views/MyPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/mileage',
		name: 'mileage',
		component: () => import('@/views/MileagePage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/reservation',
		name: 'reservation',
		component: () => import('@/views/ReservationPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/reservationWaiting',
		name: 'reservationWaiting',
		component: () => import('@/views/ReservationWaitingPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/reservationApp',
		name: 'reservationApp',
		component: () => import('@/views/ReservationAppPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/shop',
		name: 'shop',
		component: () => import('@/views/ShopPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/inquiry',
		name: 'inquiry',
		component: () => import('@/views/InquiryPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/inquiry/:id',
		name: 'inquiryDetail',
		component: () => import('@/views/InquiryDetailPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/inquiryEdit',
		name: 'inquiryEdit',
		component: () => import('@/views/InquiryEditPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/promotion',
		name: 'promotion',
		component: () => import('@/views/PromotionPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/promotion/:id',
		name: 'promotionDetail',
		component: () => import('@/views/PromotionDetailPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/contract',
		name: 'contract',
		component: () => import('@/views/ContractPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/asStamp',
		name: 'asStamp',
		component: () => import('@/views/AsStampPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/asStampHistory',
		name: 'asStampHistory',
		component: () => import('@/views/AsStampHistoryPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/coupon',
		name: 'coupon',
		component: () => import('@/views/CouponPage'),
		beforeEnter: requireAuth,
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/LoginPage'),
		beforeEnter: guestAuth,
	},
	{
		path: '/signup',
		name: 'signup',
		component: () => import('@/views/SignupPage'),
		beforeEnter: guestAuth,
	},
	{
		path: '/findId',
		name: 'findId',
		component: () => import('@/views/FindIdPage'),
		beforeEnter: guestAuth,
	},
	{
		path: '/findPassword',
		name: 'findPassword',
		component: () => import('@/views/FindPasswordPage'),
		beforeEnter: guestAuth,
	},
	{
		path: '/maintenance',
		name: 'maintenance',
		component: () => import('@/views/MaintenancePage'),
		beforeEnter: guestAuth,
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

// // 쿠키 읽기 함수
// function getCookie(name) {
// 	const value = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
// 	return value ? value.pop() : null;
// }

// // 전역 가드
// router.beforeEach(async (to, from, next) => {
// 	const cookieName = 'allow_access';

// 	// 현재 날짜와 시간을 가져옵니다.
// 	const currentDateTime = new Date();

// 	// 기준 날짜와 시간을 설정합니다 (2025년 4월 28일 17시).
// 	const checkDateTime = new Date('2025-04-28T17:00:00');

// 	if (
// 		getCookie(cookieName) !== 'fe16bee2-ab7f-40d9-8fbd-7bc02ff0f23e' &&
// 		to.name !== 'maintenance' &&
// 		currentDateTime >= checkDateTime
// 	) {
// 		next('/maintenance');
// 	} else {
// 		const loginToken = getLoginToken();

// 		if (loginToken) {
// 			await store.dispatch('userStore/getUserInfo', { loginToken });
// 		}

// 		next();
// 	}
// });
router.beforeEach(async (to, from, next) => {
	const loginToken = getLoginToken();

	if (loginToken) {
		await store.dispatch('userStore/getUserInfo', { loginToken });
	}

	next();
});

export default router;
